import * as LocationFeaturesUploads from "$lib/data/generated/uploads/location/Features/uploads.js";
import * as LocationFeaturesForPageLocationServicesUploads from "$lib/data/generated/uploads/location/Features For Page Location Services/uploads.js";
import * as LocationLocationUploads from "$lib/data/generated/uploads/location/Location/uploads.js";
import * as LocationPageBannerUploads from "$lib/data/generated/uploads/location/PageBanner/uploads.js";
import * as LocationSideBySideUploads from "$lib/data/generated/uploads/location/SideBySide/uploads.js";

export const uploads = {
  ...LocationFeaturesUploads.uploads,
  ...LocationFeaturesForPageLocationServicesUploads.uploads,
  ...LocationLocationUploads.uploads,
  ...LocationPageBannerUploads.uploads,
  ...LocationSideBySideUploads.uploads
};
